<template>

  <div>

    <div>

      <div class="mr-5">

        <h3 class="mb-0">Rapportage</h3>
        <small class="block mb-4 text-muted">Bekijk hier hoe de organisatie presteert met het behandelen van
          meldingen.</small>

      </div>

      <filters class="flex-shrink-0 ml-auto"/>

    </div>

    <div class="flex flex-wrap mt-4">

      <div class="w-full my-4">

        <div class="flex flex-wrap -mx-4">

          <div class="w-1/3 px-4 mb-4">

            <response-time class="h-full"/>

          </div>

          <div class="w-1/3 px-4 mb-4">

            <notifications-type-count-pie-chart
                class="h-full"
                :subEventNotifications="subEventNotifications"
            />

          </div>

          <div class="w-1/3 px-4 mb-4">

            <notifications-response-count-pie-chart class="h-full"/>

          </div>

        </div>

      </div>

      <div class="flex flex-wrap w-full">

        <div class="w-full mb-8">

          <notifications-response-bar-chart/>

        </div>

        <div class="w-full">

          <div class="flex flex-wrap -mx-4">

            <div class="w-full px-4 mb-4">
              <employee-online-grid/>
            </div>

            <div class="w-full px-4 mb-4">
              <employee-score-grid/>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>
import Filters from "./Filters";

import NotificationsResponseBarChart from "./plugins/NotificationsResponseBarChart";
import NotificationsTypeCountPieChart from "./plugins/NotificationsTypeCountPieChart";
import NotificationsResponseCountPieChart from "./plugins/NotificationsResponseCountPieChart";
import ResponseTime from "./plugins/ResponseTime";
import EmployeeOnlineGrid from "./plugins/EmployeeOnlineGrid";
import EmployeeScoreGrid from "./plugins/EmployeeScoreGrid";

import ChartDataLabels from 'chartjs-plugin-datalabels';

// Unregister it from all the charts, we'll manually re-enable it later
//Chart.plugins.unregister(ChartDataLabels);

export default {
  name: 'admin-dashboard',
  components: {
    Filters,
    EmployeeOnlineGrid,
    EmployeeScoreGrid,
    ResponseTime,
    NotificationsResponseCountPieChart,
    NotificationsResponseBarChart,
    NotificationsTypeCountPieChart,
  },

  props: {
    subEventNotifications: Array,
  },

}
</script>

<style lang="scss" scoped>

</style>
